import { Volume2 } from "lucide-react";
import { useCallback, useState } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useI18n } from "@/locales/client";

const AudioButton = ({ question }: { question: string }) => {
  const [isSpeaking, setIsSpeaking] = useState(false);
  const t = useI18n();

  const speakText = useCallback((text: string) => {
    if ("speechSynthesis" in window) {
      const synth = window.speechSynthesis;
      const speech = new SpeechSynthesisUtterance(text);

      speech.lang = "en-GB";
      speech.rate = 1.0;
      speech.pitch = 1.0;
      speech.volume = 1.0;

      const setupVoice = (voices: SpeechSynthesisVoice[]) => {
        speech.voice =
          voices.find(
            (voice) =>
              voice.lang === "en-GB" &&
              voice.name.includes("Google") &&
              voice.name.includes("Female"),
          ) ||
          voices.find((voice) => voice.lang === "en-GB") ||
          voices[0];

        setIsSpeaking(true);
        speech.onend = () => setIsSpeaking(false);
        speech.onerror = (event) => {
          console.error("Speech synthesis error:", event);
          setIsSpeaking(false);
        };

        synth.speak(speech);
      };

      const voices = synth.getVoices();
      if (voices.length === 0) {
        synth.onvoiceschanged = () => setupVoice(synth.getVoices());
      } else {
        setupVoice(voices);
      }
    } else {
      console.error("Speech synthesis not supported");
    }
  }, []);

  const handleAudioClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (isSpeaking) return;
    event.stopPropagation();
    const textToRead = question;
    speakText(textToRead);
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      disabled={isSpeaking}
      className={cn(
        "gap-1 flex items-center justify-center text-xs font-medium size-9",
      )}
      onClick={handleAudioClick}
    >
      <Volume2 className={cn("size-4")} />
      <span className="sr-only">{t("quiz.audio.play")}</span>
    </Button>
  );
};

export default AudioButton;
